import { P2GCheckBoxLegacy, P2GChip, P2GGrid, P2GLink, P2GText, P2GTextBox } from '@parcel2go/core-ui';
import { useEffect, useState } from 'react';
import { useRefinementList } from 'react-instantsearch-core';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface IConnectedRefinementListProps {
  attribute: string;
  showMore: boolean;
  searchable?: boolean;
  limit: number;
}

const ConnectedRefinementList: React.FC<IConnectedRefinementListProps> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const [search, setSearch] = useState<string>('');
  const [extended, setExtended] = useState<boolean>(false);
  const refinement = useRefinementList({
    attribute: props.attribute,
    limit: props.limit,
    showMore: props.showMore
  }) as any;

  useEffect(() => {
    if (typeof refinement.searchForItems === 'function') {
      refinement.searchForItems(search);
    }
  }, [search]);

  return (
    <>
      {(refinement.items.length > 10 || extended) && (
        <P2GGrid item>
          <P2GTextBox id="txtSearch" label="Search" value={search} onChange={setSearch} fullWidth />
        </P2GGrid>
      )}
      {refinement.items.map(
        (item, i) =>
          (i < props.limit || extended) && (
            <P2GGrid item key={`${item.label}`}>
              <P2GCheckBoxLegacy
                id={`chk_${item.label}`}
                labelPlacement="end"
                variant="primary"
                error={false}
                label={
                  <P2GGrid container spacing={1} alignItems="center">
                    <P2GGrid item>
                      <P2GText variant="caption">{item.label}</P2GText>
                    </P2GGrid>
                    <P2GGrid item>
                      <P2GChip size="small" color="info" label={item.count.toLocaleString()} onClick={() => {}} />
                    </P2GGrid>
                  </P2GGrid>
                }
                onChange={() => refinement.refine(item.value)}
                checked={item.isRefined}
              />
            </P2GGrid>
          )
      )}
      {props.showMore && !extended && refinement.items.length > props.limit && (
        <P2GGrid item>
          <P2GLink onClick={() => setExtended(!extended)}>
            {t('CONNECTED_REFINEMENT_SHOW_MORE', { defaultValue: 'Show More' })}
          </P2GLink>
        </P2GGrid>
      )}
    </>
  );
};

export default ConnectedRefinementList;
